import { css, useTheme } from '@fable/theme'
import { Page } from 'components/Page'
import { useTypedSelector } from 'hooks'
import { PressRow } from 'components/press_row'
import {
  MLPFAQs,
  MLPHeader,
  MLPSection,
  MLPDownloadAppCallout,
  MLPClubsBanner,
  MLPHero,
  MLPBookCallout,
  MLPClubCallout,
} from 'components/marketing_landing_page'

const ReaderLandingPage = () => {
  const { colors, mediaQueries } = useTheme()
  const { isVerifying } = useTypedSelector(({ auth }) => auth)

  if (isVerifying) return null

  return (
    <Page
      head={{
        title: 'Read anytime, anywhere with friends',
        description:
          'Browse, buy, and read interactive ebooks on Fable — the app for social reading.',
        canonical: true,
      }}
      className={css`
        position: relative;
        overflow: hidden;
      `}
    >
      <MLPHeader swap />
      <MLPHero
        subheader={{ text: 'Read anytime, anywhere' }}
        header={{ text: 'with friends' }}
        description={{
          text: 'Browse, buy, and read interactive ebooks on Fable — the app for social reading.',
        }}
      />
      <MLPSection>
        <PressRow />
      </MLPSection>
      <MLPBookCallout reverse />
      <div
        className={css`
          position: relative;
        `}
      >
        <MLPClubCallout
          className={css`
            position: relative;
            z-index: 2;
            margin-top: 132px;
            ${mediaQueries.mobileL} {
              margin-top: 160px;
            }
          `}
        />
        <span
          className={css`
            display: block;
            width: 100%;
            height: 50%;
            position: absolute;
            inset: auto auto 0 0;
            background: linear-gradient(
              rgba(255, 255, 255, 0),
              ${colors.uiPearlExtraLight}
            );
          `}
        />
      </div>
      <div
        className={css`
          padding: 100px 0 0;
          background-color: ${colors.uiPearlExtraLight};
          ${mediaQueries.mobileL} {
            padding-top: 160px;
          }
        `}
      >
        <MLPClubsBanner />
        <MLPSection stretch>
          <MLPDownloadAppCallout />
        </MLPSection>
        <MLPSection
          id="faqs"
          className={css`
            padding-bottom: 100px;
            ${mediaQueries.mobileL} {
              padding-bottom: 160px;
            }
          `}
          stretch
        >
          <MLPFAQs />
        </MLPSection>
      </div>
    </Page>
  )
}

export default ReaderLandingPage
